'use client';
import  CustomCheckBox  from '@/components/shared/custom-check-box/custom-check-box.component';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation } from '@/hook';
import classes from './styles.module.scss';
import Image from 'next/image';

const CheckBoxGroup = ({
    text,
    selected,
    checkBoxClicked,
    value,
    img,
}: {
    text: string;
    value: string;
    selected: boolean;
    checkBoxClicked: (text: string) => void;
    img?: string | undefined;
}) => {
    const { t, IS_RTL = true } = useTranslation();
    // to avoid calling makeClicked twice when clicking on the chechbox directly
    const customCheckBoxClicked = () => {
        return;
    };
    return (
        <button
            onClick={() => checkBoxClicked(value)}
            className={`${classes.container} ${selected ? classes.active : ''}`}
        >
            <div className={classes.container__content}>
                {img && (
                    <Image
                        width={28}
                        height={28}
                        style={{
                            width: '28px',
                            marginRight: IS_RTL ? '' : '12px',
                            marginLeft: IS_RTL ? '12px' : '',
                        }}
                        src={img}
                        alt={text}
                    />
                )}
                {/*
            @eslint-disable-next-line @typescript-eslint/ban-ts-comment
          @ts-ignore */}
                <Typography
                    className={classes.container__content__text}
                    variant={'body2Medium'}
                >
                    {t(text as unknown as TemplateStringsArray)}
                </Typography>
            </div>
            <CustomCheckBox
                selected={selected}
                checkBoxClicked={customCheckBoxClicked}
            />
        </button>
    );
};

export default CheckBoxGroup;
